<template>
  <main v-if="empresa==='tgmex'" style="background-color: white">
    <div class="container-fluid">
      <div class="row no-gutter">
        <div class=" col m4 l6" style="padding: 0px !important;">
          <img style="width: 110vh; height:95vh; margin-right: 20px" src="https://recarga-te.com/dist/tgmexbg.jpg">
        </div>
        <div class="m8 l6 col">
          <div class="login d-flex align-items-center py-5">
            <div class="container">
              <div class="row">
                <div class="m9 col l8 mx-auto">
                  <img src="https://recarga-te.com/dist/tgmex.jpg" width="500">
                  <div class="color-card" style="backgroundColor: rgba(0,0,0,0);">
                    <form @submit.prevent="enviar">
                      <div class="input-field col s12 offset-s2">
                        <i class="material-icons prefix">account_circle</i>
                        <input id="input-usuario3" type="text" v-model="usuario">
                        <label for="input-usuario3">Usuario</label>
                      </div>
                      <div class="input-field col s12 offset-s2">
                        <i class="material-icons prefix">fingerprint</i>
                        <input id="input-password2" type="password" v-model="password">
                        <label for="input-password2">Contraseña</label>
                      </div>
                      <div class="col s10 offset-s3">
                        <span class="mensaje-login"> {{ msg }} </span>
                      </div>
                      <button type="submit" style="margin-left: 100px"
                              class="waves-effect waves-light btn boton-personalizado"
                              :style="{'background-color': accentColor}">Iniciar sesión
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Page Content -->
    <div class="container">

      <!-- Page Heading -->
      <h1 class="my-4">¿Quiénes somos?
        <small>Tu primera opción</small>
      </h1>

      <div class="row">
        <div class="l6 col  m4">
          <div class="card">
            <div class="card-image"><img
                src="https://images.unsplash.com/photo-1488998427799-e3362cec87c3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1050&q=80"
                alt="">
              <span class="card-title">
                Visión
              </span>
            </div>

            <div class="card-content">
              <p>Ser una empresa en constante renovación con los equipos telefónicos de vanguardia dando el mejor
                servicio en el área metropolitana conociendo las necesidades de cada cliente para brindar un mejor
                servicio.</p>
            </div>
          </div>
        </div>
        <div class="col l6 m4">
          <div class="card">
            <div class="card-image"><img
                src="https://images.unsplash.com/photo-1560209617-059c0bd661ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1051&q=80"
                alt="">
              <span class="card-title">
                Misión
              </span>
            </div>

            <div class="card-content">
              <p class="card-text">Proveer la mejor tecnología en telefonía con paquetes a tu medida, para facilitar la
                comunicación en tu trabajo o con tu familia.</p>
            </div>
          </div>
        </div>

      </div>
      <br><br><br>
    </div>

    <!-- /.row -->

  </main>
  <main v-else>
    <div class="navbar-fixed" style="background-color: rgba(0,0,0,0)">
      <nav v-show="hideNav==='0'" style="background-color: rgba(0,0,0,0)"
           :style="'backgroundColor:'+backgroundColor+';'">
        <div class="nav-wrapper center-align">
          <img v-if="dominioI=='zaz'" class="logo-navbar " src="https://recarga-te.com/dist/zaz.jpg"/>
          <img v-else class="logo-navbar " :src='image'/>
        </div>
      </nav>
    </div>
    <div class="fondo-personalizado">
      <video autoplay muted v-if="gettedVideo">
        <source :src="imagenFondo" type="video/mp4">
      </video>
      <img :src="imagenFondo" v-if="gettedVideo">
    </div>
    <div class="row elevacion">

      <div :class="'col s12 m10 l6  offset-m1 ' + izquierdoLogin" style="backgroundColor: rgba(0,0,0,0);">

        <div class="card-panel center-align quitar-paddingQr" style="padding: 1.3rem" v-if="errorCode == 13">
          <div class="row">
             <span class="page-title">
               Verificación en dos pasos
            </span>
          </div>
          <div class="row" style="text-align: left">
            <p>Buena tarde estimado administrador.
              Por motivos de seguridad hemos implementado el mecanismo de doble autenticación para usuarios
              administradores.
              Los pasos son:</p>

          </div>
          <div class="row" style="text-align: left">
            <p>
              1.- Descargar la aplicación de google en:
              <a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=es_MX">Play
                Store</a> o
              <a href="https://apps.apple.com/es/app/google-authenticator/id388497605">App Store</a>
              <br>
              2.- Escanear dentro de la aplicación el QR aquí mostrado para vincular el acceso con su sistema y seguir
              con las instrucciones de google
              <br>
              3.- Una vez vinculado, colocar en la siguiente ventana el código de verificación provisto por la app
              móvil
              <br>
              4.- Click en Enviar para iniciar sesión
              <br>
              <br>
              Para cualquier duda por favor comunicarse al <a
                href="https://wa.me/5534316959?text=Hola,%20necesito%20ayuda%20con%20la%20verificacion%20en%20dos%20pasos.">5534316959</a>
            </p>
          </div>

          <img id="outputImage" alt="Base64 Image" :src="qrCodeUrl" class="qrVerify"/>
          <button class="waves-effect waves-light btn boton-personalizado" style="margin-bottom: 2rem"
                  :style="{'background-color': accentColor}" @click="siguiente">Siguiente
          </button>
        </div>
        <div class="card-panel center-align quitar-padding" style="padding: 1.3rem" v-else-if="errorCode == 14">
            <span class="page-title">

              Código de verificación
             </span>
          <div class="color-card" style="backgroundColor: rgba(0,0,0,0);">
            <form @submit.prevent="enviarCodigo">

              <div class="input-field col s12  m10 offset-m1">
                <i class="material-icons prefix">https</i>
                <input id="input-codegoogle" type="text" v-model="googleCode">
                <label for="input-codegoogle">Código de verificación</label>
              </div>

              <div class="col s10 offset-s1">
                <a @click="crearNuevoQR" style="cursor: pointer">¿Aun no has escaneado un Código QR?</a>
              </div>
              <div class="col s10 offset-s1">
                <span class="mensaje-login"> {{ msg }} </span>
              </div>
              <button type="submit" class="waves-effect waves-light btn boton-personalizado"
                      :style="{'background-color': accentColor}">Enviar
              </button>
            </form>
          </div>
        </div>
        <div class="card-panel center-align quitar-padding" style="padding: 1.3rem" v-else-if="errorCode == 15">
            <span class="page-title">
              Código de verificación
            </span>
          <div class="color-card" style="backgroundColor: rgba(0,0,0,0);">
            <form @submit.prevent="enviarCodigo">
              <div class="input-field col s12  m10 offset-m1">
                <i class="material-icons prefix">https</i>
                <input id="input-codegoogle" type="text" v-model="googleCode">
                <label for="input-codegoogle">Código de verificación</label>
              </div>
              <div class="col s10 offset-s1">
                <span class="mensaje-login"> {{ msg }} </span>
              </div>
              <button type="submit" class="waves-effect waves-light btn boton-personalizado"
                      :style="{'background-color': accentColor}">Enviar
              </button>
            </form>
          </div>
        </div>
        <div class="card-panel center-align quitar-padding" style="padding: 1.3rem" v-else>
            <span class="page-title">
              Inicia sesión
            </span>
          <div class="color-card" style="backgroundColor: rgba(0,0,0,0);">
            <form @submit.prevent="enviar">
              <div class="input-field col s12  m10 offset-m1 l8 offset-l2">
                <i class="material-icons prefix">account_circle</i>
                <input id="input-usuario" type="text" v-model="usuario">
                <label for="input-usuario">Usuario</label>
              </div>
              <div class="input-field  col s12  m10 offset-m1 l8 offset-l2">
                <i class="material-icons prefix">fingerprint</i>
                <input id="input-password" type="password" v-model="password">
                <label for="input-password">Contraseña</label>
              </div>
              <div class="col col s12  m10 offset-m1 l8 offset-l2">
                <span class="mensaje-login"> {{ msg }} </span>
              </div>
              <div class="col col s12  m10 offset-m1 l8 offset-l2">
                <button type="submit" class="waves-effect waves-light btn boton-personalizado"
                        :style="{'background-color': accentColor}">Iniciar sesión
                </button>
              </div>

            </form>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {iniciarSesion, getEmpresa, setTheme, iniciarSesionVerificada, crearNuevoQR} from '@/api/api'
import {mapState} from 'vuex'
import {setTokenSentToServer, refreshToken} from '@/firebaseClient'

let gEmpresa = ''
let intento = 1
export default {
  name: "login",
  data() {
    return {
      errorCode: 1,
      msg: '',
      usuario: '',
      password: '',
      gettedVideo: false,
      empresa: "",
      dominioI: "",
      intento: 1,
      qrCodeUrl: '',
      googleCode: ''
    }
  },
  methods: {
    siguiente() {
      this.errorCode = 14
      this.msg = ''
      // setTimeout(() => {
      //   M.AutoInit();
      // }, 550)
    },
    crearNuevoQR() {
      console.log(`asd`)
      crearNuevoQR(this.usuario, this.password, gEmpresa).then(resp => {
        console.log(resp, `esta es la respuesta`)
        this.errorCode = 13
        this.qrCodeUrl = resp.qrCodeUrl ? resp.qrCodeUrl : ''
      }).catch(error => {
        console.log(error)
        this.msg = error.mensaje ? error.mensaje : 'Error al generar el código QR'
      })
    },
    enviarCodigo() {
      this.$store.commit('ponerBarra')

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async position => {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          navigator.permissions.query({name: 'geolocation'}).then(result => {
            if (result.state === 'granted') {
              return iniciarSesionVerificada(this.usuario, this.password, this.googleCode, gEmpresa, latitude, longitude)
            } else if (result.state === 'prompt') {
              Promise.reject({mensaje: 'Activa los permisos de ubucacion'})
            } else if (result.state === 'denied') {
              Promise.reject({mensaje: 'Activa los permisos de ubucacion'})
            }
          }).then(respuesta => {

            console.log(respuesta, `esta es la respuesta`)
            this.$store.commit('quitarBarra')
            if (respuesta.token) {
              this.msg = ''
              localStorage.setItem('empresa', gEmpresa)
              localStorage.setItem('maxRecargas', respuesta.empresa.maxRecargas)
              localStorage.setItem('recargaSinUsuario', respuesta.empresa.recargaSinUsuario)
              localStorage.removeItem('token')
              localStorage.removeItem('nivel2')
              localStorage.removeItem('id')
              localStorage.removeItem('nombre')
              localStorage.setItem('nivel', respuesta.nivel)
              localStorage.setItem('isMonto', respuesta.isMonto)
              localStorage.setItem('username', respuesta.username)
              window.localStorage.setItem('MRD', respuesta.MRD)
              localStorage.setItem('token', respuesta.token)
              this.$router.push({name: 'recargas'})
            } else {
              this.msg = 'Error inesperado, intente mas tarde'
            }
            if (gEmpresa == `demo`) {
              console.log(`es demo`)
              setTokenSentToServer(false)
              refreshToken()
            }

          }).catch(error => {
            this.$store.commit('quitarBarra')
            console.log(error)
            this.msg = error.mensaje ? error.mensaje : 'Usuario o contraseña incorrectos, intenta de nuevo'
          })
        }, error => {
          console.error('Error al obtener la ubicación:', error.message);
          this.msg =  'Por favor activa los permisos de ubicación antes de continuar'
        });
      } else {
        alert('Geolocalización no soportada por este navegador.');
      }


    },
    enviar() {
      this.$store.commit('ponerBarra')
      iniciarSesion(this.usuario, this.password, gEmpresa).then(respuesta => {
        console.log(respuesta, `esta es la respuesta`)
        this.$store.commit('quitarBarra')
        if (respuesta.token) {
          this.msg = ''
          localStorage.setItem('empresa', gEmpresa)
          localStorage.setItem('maxRecargas', respuesta.empresa.maxRecargas)
          localStorage.setItem('recargaSinUsuario', respuesta.empresa.recargaSinUsuario)
          localStorage.removeItem('token')
          localStorage.removeItem('nivel2')
          localStorage.removeItem('id')
          localStorage.removeItem('nombre')
          localStorage.setItem('nivel', respuesta.nivel)
          localStorage.setItem('isMonto', respuesta.isMonto)
          localStorage.setItem('username', respuesta.username)
          window.localStorage.setItem('MRD', respuesta.MRD)
          localStorage.setItem('token', respuesta.token)
          this.$router.push({name: 'recargas'})
        } else {
          this.msg = 'Error inesperado, intente mas tarde'
        }
        if (gEmpresa == `demo`) {
          console.log(`es demo`)
          // setTokenSentToServer(false)
          // refreshToken()
        }

      }).catch(error => {
        this.$store.commit('quitarBarra')
        console.log(error)
        this.errorCode = error.code ? error.code : 1
        this.qrCodeUrl = error.qrCodeUrl ? error.qrCodeUrl : ''
        this.msg = error.mensaje ? error.mensaje : 'Usuario o contraseña incorrectos, intenta de nuevo'
        this.msg = this.errorCode == 14 ? '' : this.msg
      })
    }
  },
  mounted() {
    this.empresa = this.$route.params.empresa
    const dominio = window.location.href

    if (dominio.includes('recargastgmex.mx')) this.empresa = 'tgmex'
    if (dominio.includes('recargaszaz.com.mx')) this.dominioI = 'zaz'
    if (this.imagenFondo.length > 1) this.gettedVideo = true
    setTimeout(() => {
      M.updateTextFields()
    }, 150)
  },
  beforeCreate() {
    let auxEmpresa = this.$route.params.empresa
    this.empresa = this.$route.params.empresa
    if (auxEmpresa === 'login') {
      const dominio = window.location.href
      if (dominio.includes('herramientasbaevi.com')) auxEmpresa = 'baevi'
      else if (dominio.includes('gmcel.com')) auxEmpresa = 'gmcel'
      else if (dominio.includes('gruposima.mx')) auxEmpresa = 'gruposima'
      else if (dominio.includes('enlaceshop.com')) auxEmpresa = 'enlaceshop'
      else if (dominio.includes('recargasgsmoviles.com.mx')) auxEmpresa = 'gsmoviles'
      else if (dominio.includes('recargastgmex.mx')) auxEmpresa = 'tgmex'
      else if (dominio.includes('recargasasec.com')) auxEmpresa = 'asec'
      else if (dominio.includes('recargasdraggomovil.com')) auxEmpresa = 'draggomovil'
      else if (dominio.includes('leiphone.com.mx')) auxEmpresa = 'leiphone'
      else if (dominio.includes('damtel')) auxEmpresa = 'damtel'
      else if (dominio.includes('recargaszaz.com.mx')) auxEmpresa = 'leiphone'
      else if (dominio.includes('cmtex.com.mx')) auxEmpresa = 'cmtex'
      else if (dominio.includes('activasimrecargas.com')) auxEmpresa = 'activasim'
      else if (dominio.includes('simcroft')) auxEmpresa = 'simcroft'
      else if (dominio.includes('innova')) auxEmpresa = 'innova'
      else if (dominio.includes('discovery')) auxEmpresa = 'discovery'
      else if (dominio.includes('devsol')) auxEmpresa = 'devsol'
      else if (dominio.includes('tridial')) auxEmpresa = 'tridial'
      else if (dominio.includes('movicell')) auxEmpresa = 'movicell'
      else if (dominio.includes('todosim')) auxEmpresa = 'todosim'
      else if (dominio.includes('eradigital')) auxEmpresa = 'eradigital'
      else if (dominio.includes('silverphone')) auxEmpresa = 'silverphone'
      else if (dominio.includes('celstar')) auxEmpresa = 'celstar'
      else if (dominio.includes('vam')) auxEmpresa = 'vam'
      else if (dominio.includes('aba')) auxEmpresa = 'damtel'


    }
    this.empresa = auxEmpresa
    console.log(auxEmpresa)
    gEmpresa = auxEmpresa
    console.log(`antes del mntenioajanh`, intento)
    if (intento === 1) {
      console.log(`entyro al imntentomjnwqk `, intento)
      getEmpresa(gEmpresa).then(response => {
        localStorage.setItem('empresa', gEmpresa)
        console.log(`hizo la peti`, intento)
        console.log(response.empresa)
        console.log('recargas:', response.empresa.recargaSinUsuario)
        this.$store.commit('theming', response.empresa)
        setTimeout(() => {
          this.gettedVideo = response.empresa.imagenFondo !== ''
        }, 10)
        const empresa = response.empresa
        setTheme(document, empresa.primaryColor, empresa.darkenColor, empresa.accentColor)
      }).catch(error => {
        console.log(error)
        intento = 2
        console.log(`error ene elro `, intento)
        M.toast({html: error.message, classes: 'rounded', displayLength: 10000})
        //this.$router.push({name: 'sinEmpresa'})
      })
    }

  },
  computed: {
    ...mapState(['primaryColor', 'accentColor', 'accentColor', 'backgroundColor', 'image', 'imagenFondo', 'izquierdoLogin', 'hideNav'])
  }
}

</script>

<style scoped>
.navbar-fixed {
  margin-top: -5px;
}

.logo-navbar {
  max-height: 80%;
  margin-top: 10px;
}

.color-card {
  background-color: white;
  margin-top: -7px;
  padding-bottom: 30px;
  padding-top: 15px;
}

.imagen-form {
  max-width: 100%;
  margin-top: -40px;
}

.quitar-padding {
  padding: 30px 0 0 0;
  margin-top: 120px;
}

.titulo-card {
  font-size: 2.3em;
  position: relative;
  font-family: "Roboto Light", sans-serif;
}

.boton-personalizado {
  min-width: 79%;
  margin-top: 15px;
  font-size: 1.2em;
  height: 40px;
  line-height: 40px;
  border: none;
}

.mensaje-login {
  color: #004b96;
  margin: 5px 0 5px 0;
}

.fondo-personalizado {
  position: absolute;
  top: 0;
  z-index: 1;
  width: 100vw;
  height: 100vh;
}

.elevacion {
  z-index: 2;
  width: 100%;
  position: absolute;
}

video {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
}

.fondo-personalizado img {
  width: 100%;
  Height: 100%;
}

:root {
  --input-padding-x: 1.5rem;
  --input-padding-y: 0.75rem;
}

.login,
.image {
  min-height: 100vh;
}

.bg-image {
  background-image: url('https://recarga-te.com/dist/tgmexbg.jpg');
  background-size: cover;
  background-position: center;
}

.login-heading {
  font-weight: 300;
}

.btn-login {
  font-size: 0.9rem;
  letter-spacing: 0.05rem;
  padding: 0.75rem 1rem;
  border-radius: 2rem;
}

.form-label-group {
  position: relative;
  margin-bottom: 1rem;
}

.form-label-group > input,
.form-label-group > label {
  padding: var(--input-padding-y) var(--input-padding-x);
  height: auto;
  border-radius: 2rem;
}

.form-label-group > label {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  margin-bottom: 0;
  /* Override default `<label>` margin */
  line-height: 1.5;
  color: #495057;
  cursor: text;
  /* Match the input under the label */
  border: 1px solid transparent;
  border-radius: .25rem;
  transition: all .1s ease-in-out;
}

.form-label-group input::-webkit-input-placeholder {
  color: transparent;
}

.form-label-group input:-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-ms-input-placeholder {
  color: transparent;
}

.form-label-group input::-moz-placeholder {
  color: transparent;
}

.form-label-group input::placeholder {
  color: transparent;
}

.form-label-group input:not(:placeholder-shown) {
  padding-top: calc(var(--input-padding-y) + var(--input-padding-y) * (2 / 3));
  padding-bottom: calc(var(--input-padding-y) / 3);
}

.form-label-group input:not(:placeholder-shown) ~ label {
  padding-top: calc(var(--input-padding-y) / 3);
  padding-bottom: calc(var(--input-padding-y) / 3);
  font-size: 12px;
  color: #777;
}

/* Fallback for Edge
-------------------------------------------------- */

@supports (-ms-ime-align: auto) {
  .form-label-group > label {
    display: none;
  }

  .form-label-group input::-ms-input-placeholder {
    color: #777;
  }
}

/* Fallback for IE
-------------------------------------------------- */

@media all and (-ms-high-contrast: none),
(-ms-high-contrast: active) {
  .form-label-group > label {
    display: none;
  }

  .form-label-group input:-ms-input-placeholder {
    color: #777;
  }
}


.card-panel {
  border-radius: 10px;
  padding-top: 15px;
  padding-bottom: 15px;
  overflow: auto;
}

.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}


.qrVerify {
  width: 15vw
}

.quitar-paddingQr {
  padding: 30px 0 0 0;
  margin-top: 10px;
}

@media (max-width: 1000px) {
  .qrVerify {
    width: 30vw
  }

  .quitar-padding {
    margin-top: 150px;
  }
}

@media (max-width: 700px) {
  .qrVerify {
    width: 40vw
  }

  .quitar-padding {
    margin-top: 150px;
  }
}

@media (max-width: 500px) {
  .qrVerify {
    width: 60vw
  }

  .quitar-padding {

    margin-top: 130px;
  }
}


</style>
